import React, {Component} from 'react';
import './CompanyProfileCard.css';

export default class CompanyProfileCard extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div className="company_profile_card_container">
				<img className="company_profile_card_image" src={this.props.image} />
				<div className="company_profile_card_title">{this.props.title}</div>
				<div className="company_profile_card_subtitle">{this.props.subtitle}</div>
			</div>
		);
	}
}
